import { GetApiTokensResponseDTO } from "~/types/api";

import { warehouseApi } from "./warehouseApi";

export type CreateApiTokenResponse = {
  fulfillmentCenterId: string;
  lastUsed: string;
  token: string;
  roles: string[];
  creationDate: string;
  expirationDate: string;
  id: Guid;
  name: string;
  userId: string;
  clientId: string;
  enabled: boolean;
};

export const apiTokensApi = warehouseApi.injectEndpoints({
  endpoints: (build) => ({
    getApiTokens: build.query<GetApiTokensResponseDTO[], void>({
      query: () => ({
        url: `/configuration/api-tokens`,
        method: "GET"
      }),
      providesTags: ["api tokens"]
    }),
    createApiToken: build.mutation<
      CreateApiTokenResponse,
      { roles: string[]; name: string; expirationDate: string }
    >({
      query: ({ roles, name, expirationDate }) => ({
        url: "/configuration/api-tokens",
        method: "POST",
        body: {
          roles,
          name,
          expirationDate
        }
      })
    }),
    revokeApiToken: build.mutation<void, { tokenId: string }>({
      query: ({ tokenId }) => ({
        url: `/configuration/api-tokens/${tokenId}/revoke`,
        method: "POST"
      }),
      invalidatesTags: ["api tokens"]
    })
  })
});
